export default __webpack_public_path__ + "media/images/lp/Top-sp-09f621b6eac3221c104e1d4c13811ad8.jpg";